<template>
    <div class="page page--light page--overflow-y-unset">
        <section class="row gradient-background flex">
            <div class="wrapper wrapper--no-max-width flex flex--column">
                <header v-if="title"
                    class="row__header"
                >
                    <back-button :isAbsolute="false"
                        :isBlack="true"
                    />

                    <h1>{{ title }}</h1>
                </header>

                <iframe v-show="iframeUrl && (!isLoading || !showLoader)"
                    id="iframe"
                    :src="iframeUrl"
                    @load="() => isLoading = false"
                />

                <loader v-if="showLoader && isLoading" />
            </div>
        </section>
    </div>
</template>

<script>
// Components
import loader from '@webapp/components/loading-spinner/loading-spinner.vue';
import backButton from '@webapp/components/back-button/back-button.vue';

export default {
    name: 'external-page',
    components: {
        loader,
        backButton,
    },
    props: {
        url: {
            type: String,
            default: '',
            required: true,
        },
        isExternal: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
            required: false,
        },
        showLoader: {
            type: Boolean,
            default: true,
        },
        onIframeMessage: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            isLoading: true,
            iframeUrl: '',
        };
    },
    watch: {
        url: {
            immediate: true,
            handler(val) {
                // In case of refresh and URL is not specified go back Home
                if (!val) {
                    this.$router.push('/');
                }

                // Open external links in a new tab
                if (this.isExternal) {
                    window.open(val);

                    // Go to the homepage to not show the blank externalPage (since the page is opened outside)
                    this.$router.push('/');

                    return;
                }

                this.isLoading = true;
                this.iframeUrl = val;

                window.addEventListener('message', this.onIframeMessage);
            },
        },
    },
    destroyed() {
        window.removeEventListener('message', this.onIframeMessage);
    },
};
</script>

<style lang="scss" scoped>
iframe {
    border: none;
    flex: 1;
}

.spinner {
    flex: 1;
    width: 100%;
    background: $white-color;
}
</style>